import { defineStore } from 'pinia'

export const useGlobalStore = defineStore({
  id: 'global',
  state: () => ({
    $page: null,
  }),
  getters: {
    phoneNumberPendingTcrUpdate() {
        if (!this.$page) {
            return false;
        }
        return this.$page.props.auth.user.organization.primary_number_status === "PendingTcrCampaignChange";
    },
    isPhoneNumberActive() {
        if (!this.$page) {
            return false;
        }

        return this.$page.props.is_phone_number_active;
    },
  },
});